/**
 * MUSKLE Member Hub Concept 02 — dashboard metrics (real data only).
 * Points: GET /apps/muskle-points/balance (balance only; full ledger on /pages/muskle-points)
 * Saved products: products only (no Productgids module)
 * Reviews: GET /apps/muskle-reviews/my-reviews (customer-safe App Proxy)
 */
(function () {
  'use strict';

  function isEnglish() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    return lang.indexOf('en') === 0;
  }

  function copy() {
    if (isEnglish()) {
      return {
        view: 'View',
        pointsLabel: 'MUSKLE Points',
        ordersLabel: 'Orders',
        reviewsLabel: 'Reviews',
        savedLabel: 'Saved',
        verifiedBuyer: 'Verified Buyer',
        viewProduct: 'View product',
        pendingNote: 'Your review is being checked by MUSKLE.',
        emptyReviews: 'You have not reviewed any products yet.',
      };
    }
    return {
      view: 'Bekijk',
      pointsLabel: 'MUSKLE Points',
      ordersLabel: 'Bestellingen',
      reviewsLabel: 'Beoordelingen',
      savedLabel: 'Opgeslagen',
      verifiedBuyer: 'Geverifieerde koper',
      viewProduct: 'Bekijk product',
      pendingNote: 'Je beoordeling wordt gecontroleerd door MUSKLE.',
      emptyReviews: 'Je hebt nog geen producten beoordeeld.',
    };
  }

  function formatInt(n) {
    var num = Number(n);
    if (!Number.isFinite(num)) return '';
    try {
      return new Intl.NumberFormat(isEnglish() ? 'en-GB' : 'nl-NL').format(Math.round(num));
    } catch (e) {
      return String(Math.round(num));
    }
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function setMetric(root, key, valueText, isAction) {
    var el = root.querySelector('[data-mmh-metric="' + key + '"]');
    if (!el) return;
    var valueEl = el.querySelector('[data-mmh-metric-value]');
    if (!valueEl) return;
    if (valueText == null || valueText === '') {
      valueEl.textContent = copy().view;
      el.classList.add('is-action');
      el.classList.remove('is-numeric');
      return;
    }
    valueEl.textContent = valueText;
    el.classList.toggle('is-action', Boolean(isAction));
    el.classList.toggle('is-numeric', !isAction);
  }

  function proxyGet(path) {
    return fetch(path, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then(function (res) {
      return res
        .json()
        .catch(function () {
          return { ok: false, _httpStatus: res.status };
        })
        .then(function (body) {
          body._httpStatus = res.status;
          return body;
        });
    });
  }

  function starsHtml(rating) {
    var n = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
    var out = '<div class="mmh-c02-stars" aria-label="' + n + ' / 5">';
    for (var i = 1; i <= 5; i += 1) {
      out += '<span' + (i > n ? ' class="is-empty"' : '') + '>★</span>';
    }
    out += '</div>';
    return out;
  }

  function productUrl(review) {
    var handle = review && review.product_handle ? String(review.product_handle).trim() : '';
    if (!handle) return '';
    var prefix = isEnglish() ? '/en' : '';
    return prefix + '/products/' + encodeURIComponent(handle);
  }

  function pickLatestReview(reviews) {
    if (!Array.isArray(reviews) || !reviews.length) return null;
    var approved = reviews.find(function (r) {
      return r && r.status === 'approved';
    });
    if (approved) return approved;
    return reviews[0];
  }

  function renderReviews(root, body) {
    var shell = root.querySelector('[data-mmh-reviews-shell]');
    if (!shell) return;
    var loading = shell.querySelector('[data-mmh-reviews-loading]');
    var stats = shell.querySelector('[data-mmh-reviews-stats]');
    var latest = shell.querySelector('[data-mmh-reviews-latest]');
    var pendingNote = shell.querySelector('[data-mmh-reviews-pending-note]');
    var empty = shell.querySelector('[data-mmh-reviews-empty]');
    var c = copy();

    if (loading) loading.hidden = true;

    if (!body || body.ok !== true || body._httpStatus === 401) {
      if (stats) stats.hidden = true;
      if (latest) {
        latest.hidden = true;
        latest.innerHTML = '';
      }
      if (pendingNote) pendingNote.hidden = true;
      if (empty) {
        empty.hidden = false;
        empty.textContent = c.emptyReviews;
      }
      setMetric(root, 'reviews', null, true);
      return;
    }

    var summary = body.summary || {};
    var approved = Number(summary.approved_count) || 0;
    var pending = Number(summary.pending_count) || 0;
    var total = Number(summary.total_count);
    if (!Number.isFinite(total)) total = approved + pending;

    setMetric(root, 'reviews', formatInt(total), false);

    var approvedEl = shell.querySelector('[data-mmh-reviews-approved]');
    var pendingEl = shell.querySelector('[data-mmh-reviews-pending]');
    if (approvedEl) approvedEl.textContent = formatInt(approved);
    if (pendingEl) pendingEl.textContent = formatInt(pending);
    if (stats) stats.hidden = false;

    if (total === 0) {
      if (latest) {
        latest.hidden = true;
        latest.innerHTML = '';
      }
      if (pendingNote) pendingNote.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }

    if (empty) empty.hidden = true;
    var review = pickLatestReview(body.reviews || []);
    if (!review) {
      if (latest) latest.hidden = true;
      if (pendingNote) pendingNote.hidden = true;
      return;
    }

    if (review.status === 'pending') {
      if (latest) {
        latest.hidden = true;
        latest.innerHTML = '';
      }
      if (pendingNote) {
        pendingNote.hidden = false;
        pendingNote.textContent = c.pendingNote;
      }
      return;
    }

    if (pendingNote) pendingNote.hidden = true;
    var title = escapeHtml(review.title || '');
    var bodyText = escapeHtml(review.body || '');
    var productName = escapeHtml(review.product_title || review.product_handle || '');
    var href = productUrl(review);
    var verified = review.verified_purchase
      ? '<div class="mmh-c02-verified"><span class="mmh-c02-verified-icon" aria-hidden="true">✓</span> ' +
        escapeHtml(c.verifiedBuyer) +
        (productName ? ' · ' + productName : '') +
        '</div>'
      : productName
        ? '<div class="mmh-c02-verified">' + productName + '</div>'
        : '';
    var productLink = href
      ? '<p class="mmh-c02-latest-review__product"><a href="' +
        escapeHtml(href) +
        '">' +
        escapeHtml(c.viewProduct) +
        '</a></p>'
      : '';

    if (latest) {
      latest.hidden = false;
      latest.innerHTML =
        starsHtml(review.rating) +
        '<h4>' +
        title +
        '</h4><p>' +
        bodyText +
        '</p>' +
        verified +
        productLink;
    }
  }

  function loadReviews(root) {
    var shell = root.querySelector('[data-mmh-reviews-shell]');
    var locale =
      (shell && shell.getAttribute('data-mmh-reviews-locale')) || (isEnglish() ? 'en' : 'nl');
    return proxyGet('/apps/muskle-reviews/my-reviews?locale=' + encodeURIComponent(locale))
      .then(function (body) {
        renderReviews(root, body);
      })
      .catch(function () {
        renderReviews(root, { ok: false });
      });
  }

  function updateSavedMosaic(root) {
    var mosaic = root.querySelector('[data-mmh-saved-mosaic]');
    if (!mosaic) return;
    var productImgs = root.querySelectorAll(
      '[data-muskle-saved-products-list] .muskle-member-hub__saved-card-image'
    );
    mosaic.innerHTML = '';
    for (var i = 0; i < productImgs.length && i < 3; i += 1) {
      var fig = document.createElement('figure');
      var img = document.createElement('img');
      img.src = productImgs[i].src;
      img.alt = productImgs[i].alt || '';
      fig.appendChild(img);
      mosaic.appendChild(fig);
    }
  }

  function countListItems(sel) {
    var list = document.querySelector(sel);
    if (!list) return 0;
    return list.querySelectorAll(':scope > li').length;
  }

  function refreshSavedMetrics(root) {
    var products = countListItems('[data-muskle-saved-products-list]');
    setMetric(root, 'saved', formatInt(products));
    var split = root.querySelector('[data-mmh-saved-split]');
    if (split) {
      split.innerHTML =
        '<span><b>' +
        formatInt(products) +
        '</b> ' +
        (isEnglish() ? 'products' : 'producten') +
        '</span>';
    }
    updateSavedMosaic(root);
  }

  function boot(root) {
    setMetric(root, 'points', null, true);
    var ordersEl = root.querySelector('[data-mmh-metric="orders"] [data-mmh-metric-value]');
    var ordersText = ordersEl ? String(ordersEl.textContent || '').trim() : '';
    if (!/^\d+$/.test(ordersText)) {
      setMetric(root, 'orders', null, true);
    }
    setMetric(root, 'reviews', null, true);
    setMetric(root, 'saved', null, true);

    loadReviews(root);

    proxyGet('/apps/muskle-points/balance')
      .then(function (body) {
        if (body && body.foundation !== true && typeof body.balance === 'number') {
          setMetric(root, 'points', formatInt(body.balance));
          var bal = root.querySelector('[data-mmh-points-balance]');
          if (bal) bal.textContent = formatInt(body.balance);
        }
      })
      .catch(function () {});

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      refreshSavedMetrics(root);
      if (tries >= 12) clearInterval(timer);
    }, 500);

    var list = root.querySelector('[data-muskle-saved-products-list]');
    if (window.MutationObserver && list) {
      new MutationObserver(function () {
        refreshSavedMetrics(root);
      }).observe(list, { childList: true, subtree: true });
    }
  }

  function init() {
    var root = document.querySelector('[data-mmh-c02-dashboard]');
    if (!root) return;
    boot(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
